import { createReadonlyBlockMiddleware } from 'components/MCTextEditor/shared/middleware/readonlyBlock'
import { SliceType } from 'components/MCTextEditor/slice/types'
import { PROCESSOR_API_SOURCE } from 'components/RichTextEditor/processor/constants'

export const readonlySmartLink = createReadonlyBlockMiddleware(
  SliceType.SMART_LINK,
  (action) => action.source === PROCESSOR_API_SOURCE,
)
